import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {ALLTIENDAS, TIENDA} from '../queries/tiendas.query';
import {getLoginUser} from './usuario.services';
import {ALLREGIONAL, REGIONAL} from '../queries/regional.query';

@Injectable()
export class RegionalServices {
  constructor(private apollo:Apollo){}

  getAllRegional(){
    return this.apollo.query<any>({
      query: ALLREGIONAL,
      variables: {
        idUser: getLoginUser()
      }
    });
  }

  getRegional(id:any){
    return this.apollo.query<any>({
      query: REGIONAL,
      variables: {
        id: id,
        idUser: getLoginUser()
      }
    });
  }
}


